import {BigWinBasicState} from '@fantasmagames/slot/src/modules/bigwin/states/BigWinBasicState';
import {BigWinModule} from '@fantasmagames/slot/src/modules/bigwin/BigWinModule';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {GameBigWinModule} from 'src/bigwin/GameBigWinModule';

export class GameBigWinBasicState extends BigWinBasicState {

	protected onBigWinWon(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;

		if (logic.getLastAvalancheMultiplier() > 1) {
			this.module.gotoState(GameBigWinModule.PLAYINGMULTIPLIER_STATE);
		} else {
			this.module.gotoState(BigWinModule.PLAYING_STATE);
		}
	}
}



// WEBPACK FOOTER //
// ./src/bigwin/states/GameBigWinBasicState.ts